import { DashboardSummeryBaseInfo, LocaleType } from "@payping/api";
import { dateFormats, jalaliNow, toUtc, utcNow } from "@payping/utils/dateUtils";

const getLocaleNowMethod = (locale: LocaleType): "jalaliNow" | "utcNow" => (locale === "fa" ? "jalaliNow" : "utcNow");
const locale = "fa";
const nowMethod = getLocaleNowMethod(locale);

export interface ListParams {
  pageNumber?: number;
  pageSize?: number;
}

const dateUtils = { jalaliNow, utcNow };

export const initialOverviewFilters: DashboardSummeryBaseInfo = {
  clientId: undefined,
  fromDate: toUtc({
    date: dateUtils[nowMethod]({
      manipulate: [{ args: ["day"], method: "startOf" }],
      toFormat: dateFormats.standard.utcDateTime,
    }).string,
  }).string,
  terminalId: undefined,
  toDate: toUtc({ date: dateUtils[nowMethod]({ toFormat: dateFormats.standard.utcDateTime }).string }).string,
};

export const initialOverviewTenDayChartFilters: DashboardSummeryBaseInfo = {
  clientId: undefined,
  fromDate: toUtc({
    date: dateUtils[nowMethod]({
      manipulate: [
        { args: [10, "day"], method: "subtract" },
        { args: ["day"], method: "startOf" },
      ],
      toFormat: dateFormats.standard.utcDateTime,
    }).string,
  }).string,
  terminalId: undefined,
  toDate: toUtc({ date: dateUtils[nowMethod]({ toFormat: dateFormats.standard.utcDateTime }).string }).string,
};
